<template lang="pug">
div
  v-layout.flex-column-phone(align-center, justify-space-between)
    h1 Overzicht aanvragen

    v-layout.grow-0.filters.flex-column-phone(align-center)
      v-select.mr-3.hidden-phone(
        :items='websites',
        item-text='domain',
        :item-value='null',
        label='Websiteprofiel',
        placeholder='Alle websiteprofielen',
        dense,
        @change='setDomain',
        solo,
        style='width: 220px',
        hide-details
        )

      v-select.mr-3.hidden-phone(
        :items='months',
        item-text='label',
        label='Periode',
        placeholder='Alles',
        dense,
        solo,
        style='width: 180px',
        hide-details,
        @change='setMonthOffset'
        )

      v-text-field(
        v-model='search',
        append-icon='fas fa-search',
        label='Zoeken',
        clearable,
        solo,
        style='width: 200px',
        hide-details
        )

      v-menu(offset-y)
        v-btn(slot='activator', color='primary') Nieuwe aanvraag
        v-list
          v-list-tile(:to='{ name: "lease details", params: { leaseId: "nieuwe-krediet-aanvraag" } }')
            v-list-tile-title Krediet
          v-list-tile(:to='{ name: "lease details", params: { leaseId: "nieuwe-financiallease-aanvraag" } }')
            v-list-tile-title Financial Lease

  v-tabs.mt-4(v-model='activeTab', slider-color='primary')
    v-tab.mr-4(key='all', :to='{ name: "all leases" }') Alle aanvragen
    v-tab.mr-4(key='private', :to='{ name: "all private leases" }') Krediet (particulier)
    v-tab.mr-4(key='business', :to='{ name: "all business leases" }') Financial Lease (zakelijk)
    v-tab(key='insurances', :to='{ name: "all insurance leases" }') Verzekeringen

  router-view
</template>

<script>
import Moment from 'moment'

function capitalize (str) {
  return str.split(' ')
    .map(s => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase())
    .join(' ')
}

export default {
  name: 'Leases',

  data () {
    return {
      activeTab: 'all',

      websites: [],

      months: [
        {
          label: 'Alles',
          value: null
        },
        {
          label: 'Deze maand',
          value: 0
        },
        {
          label: 'Vorige maand',
          value: -1
        }
      ],

      search: this.$store.state.filters.search
    }
  },

  methods: {
    setDomain (website) {
      if (!website.id) {
        this.$store.commit('filters/clearDomain')
      } else {
        this.$store.commit('filters/setDomain', {
          domain: website.domain
        })
      }
    },

    setMonthOffset (offset) {
      this.$store.commit('filters/setMonthOffset', {
        offset
      })
    }
  },

  async created () {
    const websites = new Array(...await this.$store.dispatch('graphqlQuery', {
      name: 'getWebsites',
      variables: {
        orgId: this.$store.state.organization.currentOrgId
      }
    }))

    if (websites.every(x => x.id)) {
      websites.unshift({
        id: null,
        domain: 'Alle websiteprofielen'
      })
    }

    this.websites = websites

    // Add last x months
    for (let i = 0; i < 5; i++) {
      const m = Moment().subtract(2 + i, 'months')

      let label = capitalize(m.format('MMMM'))

      if (m.get('year') !== Moment().get('year')) label += ` ${m.format('YYYY')}`

      this.months.push({
        label,
        value: -2 - i
      })
    }
  },

  watch: {
    search (v) {
      this.$store.commit('filters/setSearch', v)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
